import { Link } from "react-router-dom";

const ENTRIES = [
  {
    type: "movie",
    title: "电影",
    desc: "院线与流媒体的热门长片，犯罪、科幻、剧情、动画一网打尽。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20vintage%20film%20projector%20beam%20cutting%20through%20dusty%20dark%20room%2C%20deep%20navy%20shadows%20with%20warm%20orange%20light%20haze%2C%20artistic%20moody%20poster%20style%2C%20stylized%20illustration%20with%20space%20for%20text&width=1200&height=700&seq=marie-cat-movie&orientation=landscape",
    icon: "ri-movie-2-line",
    to: "/category/movie",
  },
  {
    type: "tv",
    title: "电视剧",
    desc: "国产、韩剧、日剧与英美剧集，完整季集资讯与深度剧情解析。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20scene%20of%20a%20cozy%20living%20room%20at%20night%20with%20a%20large%20screen%20casting%20warm%20orange%20glow%2C%20deep%20navy%20interior%20shadows%2C%20relaxed%20evening%20mood%2C%20artistic%20stylized%20illustration%20with%20negative%20space&width=1200&height=700&seq=marie-cat-tv&orientation=landscape",
    icon: "ri-tv-2-line",
    to: "/category/tv",
  },
];

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
      {ENTRIES.map((entry) => (
        <Link
          key={entry.type}
          to={entry.to}
          className="group relative rounded-lg overflow-hidden h-[220px] md:h-[260px] cursor-pointer"
        >
          <img
            src={entry.image}
            alt={`${entry.title}分类入口`}
            title={`${entry.title} - 分类浏览`}
            className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-primary-950/90 via-primary-950/45 to-transparent"></div>
          <div className="relative z-10 h-full p-6 flex flex-col justify-end">
            <span className="w-11 h-11 rounded-md bg-accent-500 text-background-50 flex items-center justify-center mb-3">
              <i className={`${entry.icon} text-2xl`}></i>
            </span>
            <h3 className="font-heading font-bold text-2xl text-background-50">{entry.title}</h3>
            <p className="mt-2 text-sm text-background-200 max-w-sm leading-relaxed">{entry.desc}</p>
            <span className="mt-4 flex items-center gap-1 text-sm font-medium text-accent-400">
              进入分类
              <i className="ri-arrow-right-line"></i>
            </span>
          </div>
        </Link>
      ))}
    </div>
  );
}